import { put, select, fork, take, race } from "redux-saga/effects";
import { dispatchGeneratorFunc } from "../helpers/helpers";
import {
  setShouldRequestInsights,
  setShouldRequestMonitoring,
} from "./requestSchedule";

const INITIAL_STATE = {
  pending: true,
  complete: false,
  error: undefined,
};

export const UNASSOCIATE_RULE_EQUIP =
  "bonfire/_BETA/triage/UNASSOCIATE_RULE_EQUIP";
export const UNASSOCIATE_RULE_EQUIP_REQUEST =
  "bonfire/_BETA/triage/UNASSOCIATE_RULE_EQUIP_REQUEST";
export const UNASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS =
  "bonfire/_BETA/triage/UNASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS";
export const UNASSOCIATE_RULE_EQUIP_REQUEST_FAIL =
  "bonfire/_BETA/triage/UNASSOCIATE_RULE_EQUIP_REQUEST_FAIL";

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case UNASSOCIATE_RULE_EQUIP_REQUEST:
      return {
        ...state,
        pending: true,
        complete: false,
        error: undefined,
      };
    case UNASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS:
      return {
        ...state,
        pending: false,
        complete: true,
        error: undefined,
      };
    case UNASSOCIATE_RULE_EQUIP_REQUEST_FAIL:
      return {
        ...state,
        pending: false,
        complete: true,
        error: action.error,
      };
    default: {
      return state;
    }
  }
}

export const unassociateEquipRule = ({ equipRuleIds }) => ({
  type: UNASSOCIATE_RULE_EQUIP,
  equipRuleIds,
});

export const deleteAssociateEquipRule = ({ equipRuleIds = [], token }) => ({
  types: [
    UNASSOCIATE_RULE_EQUIP_REQUEST,
    UNASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS,
    UNASSOCIATE_RULE_EQUIP_REQUEST_FAIL,
  ],
  promise: (client) =>
    client.delete("/synco/equipRule/associate", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        equipRuleIds,
      },
    }),
});

const getAuthUser = (state) => state.auth.user;
export function* unassociateEquipRuleFlow(equipRuleIds) {
  try {
    const user = yield select(getAuthUser);
    // Check that user has necessary permissions to make request
    if (!user.rolesRestriction) throw Error("Unable to authenticate user");

    // validate that at least one equipRuleId has been given
    if (equipRuleIds.length < 1) throw Error("No equip rules given");

    yield fork(dispatchGeneratorFunc, deleteAssociateEquipRule, {
      token: user.token,
      equipRuleIds,
    });

    const { success, failure } = yield race({
      success: take(UNASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS),
      failure: take(UNASSOCIATE_RULE_EQUIP_REQUEST_FAIL),
    });

    if (failure) {
      throw new Error("Failed to associate");
    }
    if (success) {
      yield put(setShouldRequestInsights(true));
      yield put(setShouldRequestMonitoring(true));
    }
  } catch (err) {
    console.error(
      `Something went wrong attempting to associate equip rule: ${err}`
    );
  }
}

export function* unassociateEquipRuleWatcher() {
  while (true) {
    const { equipRuleIds } = yield take(UNASSOCIATE_RULE_EQUIP);
    yield fork(unassociateEquipRuleFlow, equipRuleIds);
  }
}
